import { getCsrfValue } from "../../api/ApiHelper";
import { resolveApiUrl } from "../../utils/url/urlResolver";

const apiUrl = resolveApiUrl("/product-comparison/removeProduct");

export function sendData(data: string) {
  return fetch(apiUrl, {
    body: JSON.stringify(data),
    method: "DELETE",
    cache: "no-cache",
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
    headers: {
      "content-type": "application/json",
      CSRFToken: getCsrfValue(),
    },
  }).then((res) => res);
}
